<ng-container [ngComponentOutlet]="currentPage().component"
              [ngComponentOutletInputs]="{data: currentPage().data, closeButton: closeButton}">
  <ng-template #closeButton>
    @if (closable()) {
      <p-button [rounded]="true"
                [text]="true"
                severity="contrast"
                icon="pi pi-times"
                (click)="ref.close()">
      </p-button>
    }
  </ng-template>
</ng-container>
@if (showContinue()) {
  <div class="mt-6 flex justify-center">
    <p-button severity="primary" size="small" (onClick)="onContinueClick()" label="Continue"/>
  </div>
}
